(function (jQuery) {
  jQuery.gfColumnSizeResizer = function (element, options) {
    const defaults = {
      title: '',
      onSelected: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);
    let $activeRow;
    const _this = this;

    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      const $gryffBody = jQuery('#gfFrame').contents().find('body').first();

      const edittingID = $gfLeftSideBar.find('#md-settings').data('edittingID');
      if (edittingID && $gryffBody.find('#' + edittingID).length > 0) {
        $activeRow = $gryffBody.find('#' + edittingID);
      }

      this.renderColumnSizeResizer();
    };

    this.init();
  };
  jQuery.fn.gfColumnSizeResizer = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfColumnSizeResizer')) {
        const plugin = new jQuery.gfColumnSizeResizer(this, options);
        jQuery(this).data('gfColumnSizeResizer', plugin);
      }
    });
  };
})(jQuery);
